import { DEMOGRAPHIC_IDS } from "../util/characteristics"
export function questionToText(question) {
	return question.map(phrase =>
		typeof phrase == 'string' ? phrase : (phrase.label || phrase.type)).join('')
}
export function questionLabel(analysis, isQueryLabel?) {
	return analysis.question.map(annotation => annotation.label || annotation.type || annotation).join('')
}
export const questionToURIComponent = question =>
	question.map(phrase => {
		if (typeof phrase == 'string' || phrase.tentative)
			return encodeText(phrase.label || phrase.type || phrase)
		let ids = !phrase.fromText && !phrase.unknown && (phrase.ids || phrase.id || phrase.originalLabel)
		return '(' + (phrase.type || '') + (ids ? ':' + ids : '') + ':' + (phrase.label == phrase.type ? '' :
				encodeLabel(phrase.label || phrase.type)) + ')'
	}).join('')

export const encodeLabel = label =>
	encodeURIComponent(label.replace(/[ ():~,\.]/g, letter => encodeMapping[letter]))
export const encodeBluntLabel = label =>
	encodeURIComponent(label.replace(/[~,\.]/g, letter => encodeMapping[letter]))
export const encodeText = label =>
	encodeURIComponent(label.replace(/[ ():]/g, letter => encodeMapping[letter]))
export const dsEscapeText = label =>
	label.replace(/[():,\.]/g, letter => encodeMapping[letter])

const encodeMapping = {' ': '_', '(': '❨', ')': '❩', ':': ';', ',': '~,', '.': '~.', '~': '~~'}
const decodeMapping = {'_': ' ', '❨': '(', '❩': ')', ';': ':', '~': '\xA0'}

export const decodeLabel = label =>
	decodeURIComponent(label).replace(/[_❨❩;~]/g, letter => decodeMapping[letter])
export const unescapeText =label =>
	label.replace(/~([~,\.])/g, '$1').replace(/[_❨❩;]/g, letter => decodeMapping[letter])

export function generateNewQuestion({ interventions, characteristics, outcomes }, { analysisType }) {
	let newQuestion = []
	let demographics = characteristics.filter(({ id }) => DEMOGRAPHIC_IDS.includes(id))
	let conditions = characteristics.filter(({ id }) => !DEMOGRAPHIC_IDS.includes(id))
	if (analysisType == 'cohort') {
		if (outcomes.length > 0) {
			newQuestion.push('What is the average ')
			newQuestion.push(...toQuestionPhrases(outcomes, 'and'))
			newQuestion.push(' rate')
		} else {
			newQuestion.push('What is the evidence')
		}
		if (characteristics.length > 0 || interventions.length > 0) {
			if (demographics.length > 0)
				newQuestion.push(' for ', ...toQuestionPhrases(demographics, 'and'), ' patients ' + (conditions.length > 0 ? 'with ' : ''))
			else if (conditions.length > 0)
				newQuestion.push(' for patients with ')
			if (conditions.length > 0)
				newQuestion.push(...toQuestionPhrases(conditions, 'and'))
			if (interventions.length > 0) {
				newQuestion.push(' using ', ...toQuestionPhrases(interventions, 'or'))
			}
		}
	} else {
		if (interventions.length > 0) {
			// still have interventions that need to be added
			let interventionPhrases = toQuestionPhrases(interventions, analysisType == 'direct' ? 'vs' : 'or')
			let vsControl = !(analysisType == 'direct' && interventions.length == 2 || analysisType == 'cohort' ||
				interventions.some(intervention => intervention.label == 'Control'))
			newQuestion.push('How ' + (interventionPhrases[0].label?.endsWith('s') ? 'do ' : 'does '), ...interventionPhrases,
				vsControl ? ' (vs control) affect ' : ' affect ')
		}
		if (outcomes.length > 0) {
			if (newQuestion.length > 0) {
				//let isPositive = outcomes[0]?.isPositive
				newQuestion.push(...toQuestionPhrases(outcomes, 'and'))
			}
			else
				newQuestion.push('How does any treatment affect ', ...toQuestionPhrases(outcomes, 'and'))
		} else if (newQuestion.length > 0)
			newQuestion.push('outcomes')
		if (characteristics.length > 0) {
			if (newQuestion.length == 0)
				newQuestion.push('What are treatments for ')
			else if (demographics.length == 0) {
				newQuestion.push(' for patients with ')
			} else
				newQuestion.push(' for ')
			if (demographics.length > 0)
				newQuestion.push(...toQuestionPhrases(demographics, 'and'), ' patients ' + (conditions.length > 0 ? 'with ' : ''))
			newQuestion.push(...toQuestionPhrases(conditions, 'and'))
		}
	}
	newQuestion.push('?') // it's a question!
	return newQuestion
}

const toQuestionPhrases = (attributes, conjunction) => {
	let last = conjunction == 'and' ? 0 : attributes.length - 1 // don't use commas with the ands, save that for the ors
	return attributes.flatMap((attribute, i) => {
		let phrases = i == 0 ? [ attribute ] : i < last ? [', ', attribute] : [' ' + conjunction + ' ', attribute]
		while (attribute = attribute.or)
			phrases.push(attribute.or ? ', ' : ' or ', attribute)
		return phrases
	})
}

export const getShortScreeningName = (name, question) => {
	question = questionToText(question)
	if (name.startsWith(question)) {
		let suffix = name.slice(question.length)
		return suffix.replace(/^\s*-\s*/, '')
	} else {
		let divider = name.match(/\?\s+-\s+/) || name.match(/\?-\s+/) || name.match(/\s+-\s+/) || name.match(/\?\s+-/) || name.match(/\?-/) || name.match(/-/)
		if (divider)
			return name.slice(divider.index + divider[0].length)
	}
	return name
}